import getDesignKey from 'editor/src/store/variants/helpers/getDesignKey';
import { DesignData } from 'editor/src/store/design/types';
import { VariationGroup } from 'editor/src/store/variants/types';

// Returns the spread count for a variant group to determine how to partition
// variants in ProductVariantList. Used by hasMultipleSpreadGroups to separate
// e.g. one-sided flyers (1 spread) from two-sided flyers (2 spreads).
//
// Lookup priority: template > designData.
// Template is the source of truth for a product's spread structure.
// designData can have a stale spread count after reflectDesignData copies
// content from a source with a different number of spreads (e.g. reflecting
// a 2-spread design onto a 1-spread template still produces 1-spread output,
// but the old designData may linger with 2 spreads until the reducer runs).
export default function getSpreadCountForGroup(
  group: VariationGroup,
  designTemplates: { [designKey: string]: DesignData },
): number | undefined {
  const firstVariant = group.variationsInfo[0];
  if (!firstVariant) return undefined;
  const designKey = getDesignKey(firstVariant.variation.productUid, firstVariant);

  // Fallback to noParam key (productUid--): addDesignTemplatesReducer stores
  // templates under both a full key (productUid-WxH-pageCount) and a noParam
  // key (productUid--). For products with page_count_limit (flyers, brochures),
  // the full key includes the design's page_count, but variant info always has
  // pageCount=undefined — causing a key mismatch. The noParam key bridges this
  // gap. Each productUid gets its own noParam entry, so different color types
  // (one-sided vs two-sided) still resolve to different templates.
  const template =
    designTemplates[designKey] ||
    designTemplates[`${firstVariant.variation.productUid}--`];

  if (template) return template.spreads.length;
  if (firstVariant.designData) return firstVariant.designData.spreads.length;
  return undefined;
}
